export default __webpack_public_path__ + "static/media/1496.b80c9c03.png";